// extracted by mini-css-extract-plugin
export default {"timerTotal":"timerTotal__xz7DKh","time":"time__pvEZkm","timeContainer":"timeContainer__KrB64e","editIcon":"editIcon__fLSOgv","editIconDisabled":"editIconDisabled__Odeo2t"};